export const LOAD_STORE = 'LOAD_STORE';
export const SET_STORE_FILTERS = 'SET_STORE_FILTERS';
export const RESET_STORE_FILTERS = 'RESET_STORE_FILTERS';
export const SET_STORE_PAGINATION = 'SET_STORE_PAGINATION';
export const TOGGLE_STORE_STATUS = 'TOGGLE_STORE_STATUS';
export const ADD_STORE = 'ADD_STORE';
export const EDIT_STORE = 'EDIT_STORE';
export const LOAD_EDITABLE_STORE = 'LOAD_EDITABLE_STORE';
export const SET_EDITABLE_STORE_DATA = 'SET_EDITABLE_STORE_DATA';
